import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingsPageComponent } from './settings-page/settings-page.component';
import { SettingsRoutingModule } from './settings-routing.module';
import { MaterialModule } from '../common/material/material.module';
import { SettingsKundenbetreuerPageComponent } from './settings-kundenbetreuer-page/settings-kundenbetreuer-page.component';
import { SettingsSchaltleitungenPageComponent } from './settings-schaltleitungen-page/settings-schaltleitungen-page.component';
import { SettingsEmailtemplatesPageComponent } from './settings-emailtemplates-page/settings-emailtemplates-page.component';
import { AppRoutingModule } from '../app-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GlobalDirectivesModule } from '../common/formvalidation/global-directives.module';
import { ServiceModule } from '../service/service.module';
import { SettingsKundenbetreuerDetailComponent } from './settings-kundenbetreuer-detail/settings-kundenbetreuer-detail.component';
import { SettingsSchaltleitungDetailComponent } from './settings-schaltleitung-detail/settings-schaltleitung-detail.component';
import { SettingsUsersPageComponent } from './settings-users-page/settings-users-page.component';
import { SettingsUserDetailComponent } from './settings-user-detail/settings-user-detail.component';
import { ValidEmailListDirective } from './settings-emailtemplates-page/valid-email-list.directive';
import {
    SettingsNetzzuordnungImportPageComponent,
} from './settings-netzzuordnung-import-page/settings-netzzuordnung-import-page.component';
import {
    SettingsNetzzuordnungImportDetailComponent,
} from './settings-netzzuordnung-import-detail/settings-netzzuordnung-import-detail.component';
import { PipeModule } from '../common/pipe/pipe.module';

@NgModule({
    declarations: [
        SettingsKundenbetreuerDetailComponent,
        SettingsPageComponent,
        SettingsKundenbetreuerPageComponent,
        SettingsSchaltleitungenPageComponent,
        SettingsEmailtemplatesPageComponent,
        SettingsSchaltleitungDetailComponent,
        SettingsUsersPageComponent,
        SettingsUserDetailComponent,
        SettingsNetzzuordnungImportPageComponent,
        SettingsNetzzuordnungImportDetailComponent,
        ValidEmailListDirective,
    ],
    imports: [
        CommonModule,
        SettingsRoutingModule,
        MaterialModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        GlobalDirectivesModule,
        ServiceModule,
        PipeModule,
    ],
})
export class SettingsModule {
}
